import { render } from "./Educations.vue?vue&type=template&id=2ae32cb8"
import script from "./Educations.vue?vue&type=script&lang=js"
export * from "./Educations.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/tools.planval.ch/tools.planval.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__